// Generated by CoffeeScript 1.12.7
/* global window:false, document: false, Cookie: false */

window.create_subscription_result_banner = function(
  bannerType,
  bannerMessage,
  displayStyle
) {
  let innerDiv, outerDiv;
  if (
    document.getElementById('email_subscription_subanner') === null &&
    document.getElementById('global-container') !== null
  ) {
    outerDiv = document.createElement('div');
    outerDiv.id = 'email_subscription_subanner';
    outerDiv.style.display = displayStyle;
    innerDiv = document.createElement('div');
    innerDiv.id = 'subscription_success_banner';
    innerDiv.className = `notification ${bannerType} five subscribe_success`;
    innerDiv.innerHTML = bannerMessage;
    outerDiv.appendChild(innerDiv);
    const globalContainer = document.getElementById('global-container');
    return globalContainer.insertBefore(outerDiv, globalContainer.firstChild);
  }
};

window.set_subscription_result_banner_text = function(bannerMessage) {
  let innerDiv;
  if (document.getElementById('subscription_success_banner') !== null) {
    innerDiv = document.getElementById('subscription_success_banner');
    return (innerDiv.innerHTML = bannerMessage);
  }
};

window.retrySubscriptionAfterFailure = function() {
  let TEN_YEARS_IN_SECONDS, visited;
  if (typeof Cookie !== 'undefined' && Cookie !== null) {
    TEN_YEARS_IN_SECONDS = 60 * 60 * 24 * 365 * 10;
    visited = parseInt(Cookie.get('subscription_visited'));
    if (isNaN(visited)) {
      visited = 1;
    } else {
      --visited;
    }
    Cookie.set('subscription_visited', visited, {
      maxAge: TEN_YEARS_IN_SECONDS * 1000,
      domain: document.domain,
    });
  }
  window.location.reload();
  return false;
};
